import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import actions from '@/store/actions'
import getters from '@/store/getters'
import state from '@/store/state'
import mutations from '@/store/mutations'
export default new Vuex.Store({ actions, getters, state, mutations })
